import { useState } from "react";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { DefaultInput } from "../../inputs/DefaultInput";
import { ColombiaIconInput } from "../../inputs/CoIombiaIconInput";
import { VerifyCellphone } from "./VerifyCellphone";
import { Primary } from "../../buttons/Primary";

export function Cellphone() {
  const [open, setOpen] = useState(false);
  const [setPhoneInput] = useState("");
  const [setShowError] = useState(false);
  const [setMessageError] = useState("");
  const [setShowViewVerifyOtp] = useState(false);

  const handleClosePanel = () => {
    setOpen(false);
    setPhoneInput("");
    setMessageError("");
    setShowViewVerifyOtp(false);
    setShowError(false);
  };

  return (
    <>
      <div className={"w-full"} onClick={() => setOpen(true)} href="#">
        <div className="cursor-pointer min-w-full">
          <div className="md:w-1/3">
            <div>
              <Primary text="Comenzar" />
            </div>
          </div>
        </div>
      </div>
      <Dialog open={open} onClose={handleClosePanel} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-darkBgLight/75 transition-opacity duration-500 ease-in-out data-closed:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-closed:translate-x-full"
              >
                <div className="flex h-full flex-col bg-darkBg tracking-tight font-walsheim">
                  <div>
                    <div className="py-6 bg-darkBg">
                      <div className="flex justify-between px-4 pt-8 ">
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={handleClosePanel}
                            className="relative text-white focus:outline-hidden"
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <ArrowLeftIcon
                              aria-hidden="true"
                              className="h-6 w-6"
                            />
                          </button>
                        </div>
                      </div>
                      <div className=" px-4 pt-8 ">
                        <div className="text-white font-bold text-xl">
                          Indicanos tu WhatsApp
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full rounded-t-3xl bg-white p-4">
                    <div className="text-grayP py-4">
                      Te enviaremos un código OTP de 6 dígitos a tu WhatsApp
                      para verificar que esté correcto
                    </div>
                    <div className="flex gap-2">
                      <ColombiaIconInput />
                      <DefaultInput
                        autoFocus={true}
                        type={"tel"}
                        name={"WhatsApp"}
                        id={"WhatsApp"}
                        autoComplete={"on"}
                        spellCheck={true}
                        required={true}
                        minLength={"10"}
                        maxLength={"10"}
                      />
                    </div>

                    <div className="grid justify-items-end pt-8">
                      <div className="grid content-center">
                        <VerifyCellphone />
                      </div>
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
